import { createSelector } from 'reselect';
import {StudentStore} from '../../../models/Store';
import {ItemsTrackingState} from './itemsTrackingReducer';

const getItemsTrackingState = (state: StudentStore) => state.tracking.items;

const noTrackedItems = (tracking: ItemsTrackingState) => tracking.trackedItems.size === 0;

export const noTrackedItemsSelector = createSelector(getItemsTrackingState, noTrackedItems);

/* Returns true if at least one item is finished */
export const areAnyItemsUnlockedSelector = createSelector(getItemsTrackingState, (itemsTracking): boolean => {
  const anyItemWasFinished = itemsTracking.finishedItems.size > 0;

  return anyItemWasFinished;
});
